import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Success from "../../components/Typography/Success"
import {
  Button,
  IconButton,
  Typography
}from "@material-ui/core"
import { 

  NavigateNextOutlined
} from '@material-ui/icons'
import {
  NavLink
} from "react-router-dom"
// import {
//   ROUTE_REQUISITION_DETAIL
// } from "../../utils/routes"
// core components
import tableStyle from "../../assets/jss/components/requisitionTableStyle";

function CustomTable({ ...props }) {

  const { classes, tableHead, tableData, tableHeaderColor,onApprove, onDecline } = props;
  
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>

          {
            tableData.length === 0 && (
              
                <TableRow>
                  <TableCell>
                    <Typography variant="h6">
                      No Items
                    </Typography>
                  </TableCell>
                </TableRow>
              
            )
          }
          
          {

            tableData.map((prop, key) => {
            return (
              <TableRow key={key}>

                <TableCell className={classes.tableCell} >
                  {prop.position_information.title}
                </TableCell>

                <TableCell className={classes.tableCell} >
                  {prop.position_information.department}
                </TableCell>

                <TableCell className={classes.tableCell} >
                  {
                    prop.sourcing.advertising.confidential === undefined ? 
                    (
                      <Typography color="error">
                          No
                      </Typography>
                    ):
                    (
                      prop.sourcing.advertising.confidential ? (<Success>Yes</Success>):(<Typography color="error">No</Typography>)
                    )
                  }
                </TableCell>
                
                {/* <TableCell className={classes.tableCell} >
                  {prop.position_information.designation}
                </TableCell> */}
{/* 
                <TableCell className={classes.tableCell} >
                  {prop.type}
                </TableCell> */}

                {/* <TableCell className={classes.tableCell} >
                  {prop.position_information.contract.type}
                </TableCell> */}

                <TableCell className={classes.tableCell} >
                  
                  {
                    prop.status === 'accepted' ? (
                        
                       <Success>
                          {prop.status}
                       </Success>
                    ):(
                      prop.status ==='pending' ? (
                        <Typography color="secondary">
                          {prop.status}
                        </Typography>
                      ):(
                        <Typography color="error">
                          {prop.status}
                        </Typography>
                      )
                      
                    )
                  }
                </TableCell>

                <TableCell className={classes.tableCell} >
                  {
                    convertdate(prop.target_date)
                  }
                </TableCell>

                <TableCell className={classes.tableCell} >
                  {
                    convertdate(prop._created)
                  }
                </TableCell>

                <TableCell className={classes.tableCell} >
                   <Button color="primary" onClick={() => onApprove(prop)}
                    variant="outlined"
                    disabled={prop.status === 'accepted' || prop.status==='declined'}>
                      Accept
                   </Button>
                </TableCell>

                <TableCell className={classes.tableCell} >
                   <Button color="secondary" onClick={() => onDecline(prop)}
                    variant="outlined"
                    disabled={prop.status === 'accepted' || prop.status==='declined'}>
                      Decline
                   </Button>
                </TableCell>

                <TableCell className={classes.tableCell} >
                  <NavLink to={`/admin/requisition/detail/${prop._id}`}>
                    <IconButton >
                        {/* <MoreVert/> */}
                        <NavigateNextOutlined/>
                    </IconButton>
                  </NavLink>
                </TableCell>

              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

function convertdate(date) {
  var d = new Date(date);
  //return d.toLocaleString().slice(0,9);
  return d.toLocaleString();
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object)
};

export default withStyles(tableStyle)(CustomTable);
